import React, {
  Dispatch,
  useCallback,
  useEffect,
  useRef,
  useState,
} from "react";
import { ItemTypes, PopupsListType } from "./RightSideMenu";
import PopUpWindowChat from "../../chat/PopUpWindowChat";
import ShowSlider from "../../mainLayer/hazardIncidentsLayers/ReportIncidentsShowSlider";
import {
  HzSidebarMap,
  openWindowsHzMap,
} from "../../mainLayer/hazardIncidentsLayers/IncidentsMenuDropDown";
import { useHzContext } from "../../provider/HzProvider";
import ReactDOM from "react-dom";
import ReportIncidentPopUp from "../../mainLayer/hazardIncidentsLayers/ReportIncidentPopUp";
import { map } from "../../mainLayer/MainLayer";
import Overlay from "ol/Overlay";
import { Coordinate } from "ol/coordinate";

type DataType = {
  title: string;
  description: string;
};

type CommentTypes = {
  username: string;
  comment: string;
  date: string;
  image: string;
};

type PopupCompType = {
  popupClose: Dispatch<React.SetStateAction<boolean>>;
};

type SideMenuPopupsType = {
  incidentId: string;
  adm4_en: string | null;
  bwater_level: string | null;
  end_time: string | null;
  hwater_level: string | null;
  img_url: string | null;
  imp_communication: string | null;
  imp_electricity: string | null;
  imp_house: string | null;
  imp_human: string | null;
  imp_response: string | null;
  imp_roadblock: string | null;
  imp_roaddamage: string | null;
  imp_water: string | null;
  impdes_communication: string | null;
  impdes_electricity: string | null;
  impdes_house: string | null;
  impdes_human: string | null;
  impdes_roadblock: string | null;
  impdes_roaddamage: string | null;
  impdes_water: string | null;
  issued_time: string | null;
  occurance_date: string | null;
  observed_date: string | null;
  tp_number: string | null;
  w_desc: string | null;
  w_name: string | null;
  w_type: string | null;
  setHzRender: () => void;
  removeItem: (id: string, type: ItemTypes) => void;
  addItem: (id: string, type: ItemTypes) => void;
  coordinatesPopup: Coordinate;
};

const SideMenuReportedIncident = (props: SideMenuPopupsType) => {
  // Selected tab
  const [selectTab, setSelectTab] = useState<string>("popupTabDetails");
  const [commentImage, setCommentImage] = useState<File | null>(null);
  const [commentMessage, setCommentMessage] = useState<string>("");
  const { HzOpenSidebarMap, removeFromHzOpenSidebarMap } = useHzContext();

  // Handel sent comment
  const handleSentComment = () => {
    setCommentImage((prevData) => null);
  };

  // Handel image load
  const handleImageLoad = () => {
    if (commentImage) {
      setCommentImage((prevData) => null);
    } else {
      const imageInput = document.createElement("input");
      imageInput.type = "file";
      imageInput.accept = "image/*";

      imageInput.onchange = (event: Event) => {
        const target = event.target as HTMLInputElement;
        const file = target.files?.[0];
        if (file) {
          setCommentImage(file);
        }
      };
      imageInput.click();
    }
  };

  useEffect(() => {
    const entries = Array.from(HzOpenSidebarMap.values());
    const lastEntryIndex = entries.length - 1;
    entries.forEach((details, index) => {
      const { coordinates, sensorId } = details;
      if (coordinates) {
        removeOverlay(sensorId!);
        if (index === lastEntryIndex) {
          // Handle last entry
          addOverlayClickItemLast(sensorId!, coordinates);
        } else {
          // Handle all other entries
          addOverlayClickItem(sensorId!, coordinates);
        }
      }
    });
  }, [HzOpenSidebarMap.size]);

  const removeHzById = (id: string) => {
    removeFromHzOpenSidebarMap(id);
    openWindowsHzMap.set(id, "close");
    props.setHzRender();
    removeOverlay(id);
    if (HzSidebarMap.has(id)) {
      HzSidebarMap.delete(id);
    }
    
  };

  const removeOverlay = (key: string) => {
    const overlays = map.getOverlays().getArray();
    const overlaysToRemove = overlays.filter(
      (overlay) => overlay.getId() === key
    );
    overlaysToRemove.forEach((overlay) => {
      map.removeOverlay(overlay);
    });
  };

  const addOverlayClickItem = (id: string, coordinates: Coordinate) => {
    const markerElement = document.createElement("div");
    markerElement.className = "location-dot animate";

    const ringElement = document.createElement("div");
    ringElement.className = "location-dot-ring";

    markerElement.appendChild(ringElement);
    const overlay = new Overlay({
      id: id,
      position: coordinates,
      positioning: "center-center",
      element: markerElement,
      stopEvent: false,
    });
    map.addOverlay(overlay);
  };

  const addOverlayClickItemLast = (id: string, coordinates: Coordinate) => {
    const markerElement = document.createElement("div");
    markerElement.className = "locationlast-dot animate";

    const ringElement = document.createElement("div");
    ringElement.className = "locationlast-dot-ring";

    markerElement.appendChild(ringElement);
    const overlay = new Overlay({
      id: id,
      position: coordinates,
      positioning: "center-center",
      element: markerElement,
      stopEvent: false,
    });
    map.addOverlay(overlay);
  };

  const [isNotRelease, setIsNotRelease] = useState<boolean>(true);

  const popupRef = useRef<HTMLDivElement | null>(null);
  const popupElement = document.createElement("earlyWarningElement");

  const mouseMoveEvent = useCallback(
    (event: MouseEvent) => {
      const sideMenu = document.getElementById("side-menu-wrapper");

      if (sideMenu && isNotRelease) {
        const sideMenuWidth = Number(
          window.getComputedStyle(sideMenu).left.slice(0, -2)
        );

        if (sideMenuWidth > event.clientX) {
          ReactDOM.render(
            <ReportIncidentPopUp
              incidentId={props.incidentId}
              adm4_en={props.adm4_en}
              bwater_level={props.bwater_level}
              end_time={props.end_time}
              hwater_level={props.hwater_level}
              img_url={props.img_url}
              imp_communication={props.imp_communication}
              imp_electricity={props.imp_electricity}
              imp_house={props.imp_house}
              imp_human={props.imp_human}
              imp_response={props.imp_response}
              imp_roadblock={props.imp_roadblock}
              imp_roaddamage={props.imp_roaddamage}
              imp_water={props.imp_water}
              impdes_communication={props.impdes_communication}
              impdes_electricity={props.impdes_electricity}
              impdes_house={props.impdes_house}
              impdes_human={props.impdes_human}
              impdes_roadblock={props.impdes_roadblock}
              impdes_roaddamage={props.impdes_roaddamage}
              impdes_water={props.impdes_water}
              issued_time={props.issued_time}
              occurance_date={props.occurance_date}
              observed_date={props.observed_date}
              tp_number={props.tp_number}
              w_desc={props.w_desc}
              w_name={props.w_name}
              w_type={props.w_type}
              onClose={handleClose}
              addItem={props.addItem}
              id={props.incidentId!}
            />,
            popupElement
          );

          const overlay = new Overlay({
            element: popupElement,
            autoPan: {
              animation: {
                duration: 250,
              },
            },
          });
          overlay.setPosition(props.coordinatesPopup);
          map.addOverlay(overlay);
          props.removeItem(props.incidentId!, "hz");
          setIsNotRelease(false);
        }
      }
    },
    [isNotRelease]
  );

  const mouseMoveEventTouch = useCallback(
    (event: TouchEvent) => {
      const sideMenu = document.getElementById("side-menu-wrapper");

      if (sideMenu && isNotRelease) {
        const sideMenuWidth = Number(
          window.getComputedStyle(sideMenu).left.slice(0, -2)
        );
        const touchX = event.touches[0].clientX; // Get touch position
  
        if (sideMenuWidth > touchX) {
          ReactDOM.render(
            <ReportIncidentPopUp
              incidentId={props.incidentId}
              adm4_en={props.adm4_en}
              bwater_level={props.bwater_level}
              end_time={props.end_time}
              hwater_level={props.hwater_level}
              img_url={props.img_url}
              imp_communication={props.imp_communication}
              imp_electricity={props.imp_electricity}
              imp_house={props.imp_house}
              imp_human={props.imp_human}
              imp_response={props.imp_response}
              imp_roadblock={props.imp_roadblock}
              imp_roaddamage={props.imp_roaddamage}
              imp_water={props.imp_water}
              impdes_communication={props.impdes_communication}
              impdes_electricity={props.impdes_electricity}
              impdes_house={props.impdes_house}
              impdes_human={props.impdes_human}
              impdes_roadblock={props.impdes_roadblock}
              impdes_roaddamage={props.impdes_roaddamage}
              impdes_water={props.impdes_water}
              issued_time={props.issued_time}
              occurance_date={props.occurance_date}
              observed_date={props.observed_date}
              tp_number={props.tp_number}
              w_desc={props.w_desc}
              w_name={props.w_name}
              w_type={props.w_type}
              onClose={handleClose}
              addItem={props.addItem}
              id={props.incidentId!}
            />,
            popupElement
          );

          const overlay = new Overlay({
            element: popupElement,
            autoPan: {
              animation: {
                duration: 250,
              },
            },
          });
          overlay.setPosition(props.coordinatesPopup);
          map.addOverlay(overlay);
          props.removeItem(props.incidentId!, "hz");
          setIsNotRelease(false);
        }
      }
    },
    [isNotRelease]
  );

  useEffect(() => {
      const handleMouseDown = () => {
        document.addEventListener("mousemove", mouseMoveEvent);
        document.addEventListener("mouseup", handleMouseUp);
      };
    
      const handleMouseUp = () => {
        document.removeEventListener("mousemove", mouseMoveEvent);
        document.removeEventListener("mouseup", handleMouseUp);
      };
    
      const handleTouchStart = () => {
        document.addEventListener("touchmove", mouseMoveEventTouch);
        document.addEventListener("touchend", handleTouchEnd);
      };
    
      const handleTouchEnd = () => {
        document.removeEventListener("touchmove", mouseMoveEventTouch);
        document.removeEventListener("touchend", handleTouchEnd);
      };
    
      if (popupRef.current) {
        popupRef.current.addEventListener("mouseenter", () => {
          popupRef.current?.addEventListener("mousedown", handleMouseDown);
          popupRef.current?.addEventListener("touchstart", handleTouchStart);
        });
      }
    
      return () => {
        document.removeEventListener("mousemove", mouseMoveEvent);
        document.removeEventListener("mouseup", handleMouseUp);
        document.removeEventListener("touchmove", mouseMoveEventTouch);
        document.removeEventListener("touchend", handleTouchEnd);
      };
    }, [mouseMoveEvent, mouseMoveEventTouch]);

  const handleClose = (incidentId: string) => {
    removeFromHzOpenSidebarMap(incidentId);
    openWindowsHzMap.set(incidentId, "close");
    if (HzSidebarMap.has(incidentId)) {
      HzSidebarMap.delete(incidentId);
    }
  };

  const title = (wType: string): string => {
    if (wType === "ILSW") {
      return "Landslide";
    } else if (wType === "IFLW") {
      return "Flood";
    } else if (wType === "ITHS") {
      return "Heavy Rain & Thunderstorm";
    } else if (wType === "HWN") {
      return "Severe Lightning";
    }
    return "Menu";
  };

  return (
    <div className={`popup`}>
      <div className={`titleWrapper`} ref={popupRef}>
        <span>{title(props.w_type!)}</span>
        <div className={`titleButtonContainer no-drag`}>
          {/* <i className={`titleIcon fullScreenIco`}></i> */}
          <i
            className={`titleIcon closeIco`}
            onClick={(e) => {
              removeHzById(props.incidentId);
            }}
            onTouchStart={(e) => {
              removeHzById(props.incidentId);
            }}
          ></i>
        </div>
      </div>
      {/* Popup tab selector */}
      <section className={"tabArea no-drag"}>
        <span
          className={`tabButton ${
            selectTab === "popupTabDetails" ? "tabSelected" : ""
          }`}
          onClick={(e) => setSelectTab("popupTabDetails")}
          onTouchStart={(e) => setSelectTab("popupTabDetails")}
        >
          details
        </span>
        <span
          className={`tabButton ${
            selectTab === "popupTabForecast" ? "tabSelected" : ""
          }`}
          onClick={(e) => setSelectTab("popupTabForecast")}
          onTouchStart={(e) => setSelectTab("popupTabForecast")}
        >
          forecast
        </span>
        <span
          className={`tabButton ${
            selectTab === "popupTab3DTerrain" ? "tabSelected" : ""
          }`}
          onClick={(e) => setSelectTab("popupTab3DTerrain")}
          onTouchStart={(e) => setSelectTab("popupTab3DTerrain")}
        >
          3D terrain
        </span>
      </section>
      <div className={`incident-wrapper`}>
        {/* Details tab data */}
        {selectTab === "popupTabDetails" && (
          <span className="title">{props.w_name}</span>
        )}
        <div
          className={`tabDataContainer detailsTabContainer ${
            selectTab === "popupTabDetails" ? "tabOpen" : ""
          }`}
        >
          {/* Left side */}
          <div className="detailsTabContainerLeft">
            {/* Details container */}
            <div className="detailsContainer">
              {/* <span className="title">Landslide Ududumbara</span> */}
              <div className="dataContainer">
                <div className="dataRow">
                  <span className="name">Description</span>
                  <span className="data">{props.w_desc}</span>
                </div>
                <div className="dataRow">
                  <span className="name">Grama Niladari Devision</span>
                  <span className="data"> {props.adm4_en}</span>
                </div>
                <div className="dataRow">
                  <span className="name">Date</span>
                  <span className="data">{props.issued_time}</span>
                </div>
                <div className="dataRow">
                  <span className="name"> Occurrence date</span>
                  <span className="data">{props.occurance_date}</span>
                </div>
                <div className="dataRow">
                  <span className="name">Observed date</span>
                  <span className="data">{props.observed_date}</span>
                </div>
                <div className="dataRow">
                  <span className="name">Telephone number</span>
                  <span className="data">{props.tp_number}</span>
                </div>
                <div className="dataRow">
                  <span className="name"> People affected</span>
                  <span className="data">{props.imp_human}</span>
                </div>
                {props.impdes_human && (
                  <div className="dataRow">
                    <span className="name">More description</span>
                    <span className="data">{props.impdes_human}</span>
                  </div>
                )}

                <div className="dataRow">
                  <span className="name">House damaged</span>
                  <span className="data">{props.imp_house}</span>
                </div>
                {props.impdes_house && (
                  <div className="dataRow">
                    <span className="name">More description</span>
                    <span className="data">{props.impdes_house}</span>
                  </div>
                )}
                <div className="dataRow">
                  <span className="name">Road blocks</span>
                  <span className="data">{props.imp_roadblock}</span>
                </div>
                {props.impdes_roadblock && (
                  <div className="dataRow">
                    <span className="name">More description</span>
                    <span className="data">{props.impdes_roadblock}</span>
                  </div>
                )}
                <div className="dataRow">
                  <span className="name">Road damages</span>
                  <span className="data"> {props.imp_roaddamage}</span>
                </div>
                {props.impdes_roaddamage && (
                  <div className="dataRow">
                    <span className="name">More description</span>
                    <span className="data">{props.impdes_roaddamage}</span>
                  </div>
                )}
                <div className="dataRow">
                  <span className="name">Electricity supply failure</span>
                  <span className="data">{props.imp_electricity}</span>
                </div>
                {props.impdes_electricity && (
                  <div className="dataRow">
                    <span className="name">More description</span>
                    <span className="data">{props.impdes_electricity}</span>
                  </div>
                )}
                <div className="dataRow">
                  <span className="name">Water supply failure</span>
                  <span className="data">{props.imp_water}</span>
                </div>
                {props.impdes_water && (
                  <div className="dataRow">
                    <span className="name">More description</span>
                    <span className="data">{props.impdes_water}</span>
                  </div>
                )}
                <div className="dataRow">
                  <span className="name">Communication supply failure</span>
                  <span className="data">{props.imp_communication}</span>
                </div>
                {props.impdes_communication && (
                  <div className="dataRow">
                    <span className="name">More description</span>
                    <span className="data">{props.impdes_communication}</span>
                  </div>
                )}
              </div>
            </div>
            {/* Comment section */}
            <div className={"commentContainer no-drag"}>
              <span className="title">{title(props.w_type!)}</span>
              <PopUpWindowChat w_id={props.incidentId} />
            </div>
          </div>
          {/* Right side */}
          <div className={"detailsTabContainerRight no-drag"}>
            <ShowSlider img_url={props.img_url} w_id={props.incidentId} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SideMenuReportedIncident;
